/* Behavior for mgn-special-shop (native cart add — no AmbrosiaFastCheckout) */
(function () {
  'use strict';

  function readVariantImageMap(section) {
    var el = section.querySelector('[data-mgn-variant-image-map]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function initMgnSpecialShop(section) {
    if (!section || section.dataset.mgnSpecialBound === 'true') return;
    section.dataset.mgnSpecialBound = 'true';

    if (!section) return;
        const sectionConfig = {
          bogoUrlParamsEnabled: section.dataset.bogoUrlParamsEnabled === 'true',
          bogoUrlParams: section.dataset.bogoUrlParams || '',
          checkoutUrl: section.dataset.checkoutUrl || '/checkout',
          giftCardAttrSubEnabled: section.dataset.giftCardAttrSubEnabled === 'true',
          giftCardAttrOtpEnabled: section.dataset.giftCardAttrOtpEnabled === 'true',
          giftCardAmount: section.dataset.giftCardAttrAmount || '',
        };

        function getGiftCardProperties(isSubscription) {
          var enabled = isSubscription
            ? sectionConfig.giftCardAttrSubEnabled
            : sectionConfig.giftCardAttrOtpEnabled;
          if (!enabled) return null;
          var amount = String(sectionConfig.giftCardAmount || '').trim();
          if (!amount) return null;
          return { _gift_card: amount };
        }

        function getPromoGuard() {
          return section.querySelector('promo-gift-guard');
        }

        function getLandingSourceValue() {
          var el = getPromoGuard();
          return el ? (el.getAttribute('landing-source') || '').trim() : '';
        }

        function parseDiscountCodes(raw) {
          var text = (raw || '').trim();
          if (!text) return [];
          return text.split(/[\n,]+/g).map(function (s) { return s.trim(); }).filter(Boolean);
        }

        function postJSON(url, bodyObj) {
          return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(bodyObj),
            credentials: 'same-origin',
          }).then(function (res) {
            var contentType = res.headers.get('content-type') || '';
            var isJson = contentType.indexOf('application/json') !== -1;
            return (isJson ? res.json() : res.text()).then(function (data) {
              if (!res.ok) {
                var msg = (data && (data.description || data.message)) || (typeof data === 'string' ? data : 'Request failed');
                throw new Error(msg);
              }
              return data;
            });
          });
        }

        function wait(ms) {
          return new Promise(function (resolve) { setTimeout(resolve, ms); });
        }

        function cartHasVisibleCount() {
          var count = document.querySelector('.n13-header__count, .cart-count-bubble');
          if (!count) return false;
          var n = parseInt(String(count.textContent).replace(/[^\d]/g, ''), 10);
          return n > 0;
        }

        function readCart() {
          return fetch('/cart.js', {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
          }).then(function (res) { return res.json(); });
        }

        // clear.js plus the 180ms pause only when the cart has lines.
        // The pause lets landing-page-tracker wipe attributes while the cart is empty.
        function clearCartIfNeeded(shouldClear) {
          if (!shouldClear) return Promise.resolve();
          var drawer = document.querySelector('cart-drawer');
          var looksEmpty = !!(drawer && drawer.classList.contains('is-empty') && !cartHasVisibleCount());
          if (!looksEmpty) {
            return postJSON('/cart/clear.js', {}).then(function () { return wait(180); });
          }
          return readCart().then(function (cart) {
            if (cart && cart.item_count > 0) {
              return postJSON('/cart/clear.js', {}).then(function () { return wait(180); });
            }
          });
        }

        function cartAddBody(items, includeSections) {
          var body = { items: items };
          if (!includeSections) return body;
          var drawer = document.querySelector('cart-drawer');
          if (!drawer || typeof drawer.getSectionsToRender !== 'function') return body;
          var ids = drawer.getSectionsToRender().map(function (section) { return section.id; }).filter(Boolean);
          if (!ids.length) return body;
          body.sections = ids.join(',');
          body.sections_url = window.location.pathname;
          return body;
        }

        // One /cart/update.js: legacy attr clears plus landing attribution.
        // beginInlineStamp tells the tracker not to send its own update for this add.
        function postAdd(items, includeSections) {
          var landing = null;
          if (window.AmbrosiaLandingTracker && typeof window.AmbrosiaLandingTracker.beginInlineStamp === 'function') {
            landing = window.AmbrosiaLandingTracker.beginInlineStamp() || {};
          }
          var added = false;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify(cartAddBody(items, includeSections)),
          }).then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) {
                var msg = (data && (data.description || data.message)) || ('Add-to-cart failed (' + res.status + ')');
                throw new Error(msg);
              }
              return data;
            }, function () {
              if (!res.ok) throw new Error('Add-to-cart failed (' + res.status + ')');
              throw new Error('Add-to-cart failed');
            });
          }).then(function (addResult) {
            added = true;
            var attributes = { _gift_card: '', freegifts_code: '' };
            if (landing) {
              Object.keys(landing).forEach(function (key) { attributes[key] = landing[key]; });
            }
            var update = postJSON('/cart/update.js', { attributes: attributes });
            // Drawer HTML does not depend on cart attributes. Checkout redirect must
            // wait, or navigation cancels the landing stamp.
            if (includeSections) {
              update.catch(function () {
                if (window.AmbrosiaLandingTracker && typeof window.AmbrosiaLandingTracker.stampNow === 'function') {
                  window.AmbrosiaLandingTracker.stampNow();
                }
              });
              return addResult;
            }
            return update.then(function () { return addResult; });
          }).catch(function (err) {
            if (window.AmbrosiaLandingTracker && typeof window.AmbrosiaLandingTracker.abortInlineStamp === 'function') {
              window.AmbrosiaLandingTracker.abortInlineStamp();
            }
            if (added && window.AmbrosiaLandingTracker && typeof window.AmbrosiaLandingTracker.stampNow === 'function') {
              window.AmbrosiaLandingTracker.stampNow();
            }
            throw err;
          });
        }

        function waitForBogoGift(knownItemCount) {
          return new Promise(function (resolve) {
            var elapsed = 0;
            var interval = 200;
            var maxWait = 3000;

            function check() {
              fetch('/cart.js', { credentials: 'same-origin' })
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  if (cart.item_count > knownItemCount) {
                    resolve(true);
                  } else {
                    elapsed += interval;
                    if (elapsed >= maxWait) {
                      resolve(false);
                    } else {
                      setTimeout(check, interval);
                    }
                  }
                })
                .catch(function () { resolve(false); });
            }

            setTimeout(check, interval);
          });
        }

        var CHECKOUT_REDIRECT_FLAG = '__oseddCheckoutRedirectUntil';

        function setCheckoutRedirectGuard(durationMs) {
          durationMs = durationMs || 6000;
          window[CHECKOUT_REDIRECT_FLAG] = Date.now() + Math.max(1000, Number(durationMs) || 6000);
        }

        function clearCheckoutRedirectGuard() {
          delete window[CHECKOUT_REDIRECT_FLAG];
        }

        function normalizeBogoParamString(rawValue) {
          if (!rawValue) return '';
          var normalized = String(rawValue).trim();
          if (!normalized) return '';

          if (normalized.indexOf('://') !== -1) {
            try {
              normalized = new URL(normalized).search.replace(/^\?/, '');
            } catch (err) {}
          }

          var queryStartIndex = normalized.indexOf('?');
          if (queryStartIndex > -1) {
            normalized = normalized.slice(queryStartIndex + 1);
          }

          normalized = normalized.replace(/^[?&]+/, '');

          var hashIndex = normalized.indexOf('#');
          if (hashIndex > -1) {
            normalized = normalized.slice(0, hashIndex);
          }

          return normalized.trim();
        }

        function applyBogoUrlParams(options) {
          if (!window.AmbrosiaBogoUrlParams) return false;
          return window.AmbrosiaBogoUrlParams.apply(sectionConfig, options);
        }

        function mergeConfiguredBogoParams(checkoutUrl) {
          if (!sectionConfig.bogoUrlParamsEnabled) return;

          var sanitizedParams = normalizeBogoParamString(sectionConfig.bogoUrlParams);
          if (!sanitizedParams) return;

          var incomingParams = new URLSearchParams(sanitizedParams);
          incomingParams.forEach(function (value, key) {
            if (!key) return;
            checkoutUrl.searchParams.set(key, value);
          });
        }

        function getDiscountCodesForPurchaseType(type) {
          type = type || getPurchaseType();
          if (type === 'otp') return parseDiscountCodes(section.dataset.otpDiscountCode || '');
          if (type === 'bundle') {
            return parseDiscountCodes(section.dataset.bestValueDiscountCode || '');
          }
          return parseDiscountCodes(section.dataset.discountCode || '');
        }

        function applyDiscountCodes(codes) {
          if (!codes.length) return Promise.resolve();
          return codes.reduce(function (chain, code) {
            return chain.then(function () {
              return fetch('/discount/' + encodeURIComponent(code), {
                method: 'GET',
                credentials: 'same-origin',
              }).then(function (res) {
                if (!res.ok) throw new Error('Discount code could not be applied.');
              });
            });
          }, Promise.resolve());
        }

        function getCheckoutUrlWithCurrentParams(discountCodes, includeBogo) {
          var checkoutBase = sectionConfig.checkoutUrl || '/checkout';
          var checkoutUrl = new URL(checkoutBase, window.location.origin);
          var currentParams = new URLSearchParams(window.location.search);

          currentParams.forEach(function (value, key) {
            checkoutUrl.searchParams.set(key, value);
          });

          if (includeBogo !== false) {
            mergeConfiguredBogoParams(checkoutUrl);
          }

          var codes = Array.isArray(discountCodes)
            ? discountCodes
            : (discountCodes ? parseDiscountCodes(discountCodes) : []);
          if (codes.length > 0) {
            checkoutUrl.searchParams.set('discount', codes.join(','));
          }

          if (checkoutUrl.origin === window.location.origin) {
            return checkoutUrl.pathname + checkoutUrl.search + checkoutUrl.hash;
          }
          return checkoutUrl.toString();
        }

        const mgnVariantImageMap = readVariantImageMap(section);
    
        const mainGallerySlider = section.querySelector('#mainProduct-gallery');

        function slideMainGalleryToFirst() {
          if (mainGallerySlider && mainGallerySlider.swiperInstance) {
            mainGallerySlider.swiperInstance.slideTo(0, 0);
            return true;
          }
          return false;
        }

        function ensureMainGallerySlideToFirst() {
          if (slideMainGalleryToFirst()) return;
          var attempts = 0;
          var id = setInterval(function () {
            attempts += 1;
            if (slideMainGalleryToFirst() || attempts > 50) clearInterval(id);
          }, 50);
        }

        const purchaseDiv = section.querySelector('.mgn-special-shop__purchase');
        const optionCards = section.querySelectorAll('[data-mgn-option]');
        const planInput = section.querySelector('.mgn-special-shop__selling-plan');
        const unlockedFreebies = section.querySelector('.mgn-special-shop__unlocked');

        let subVariantId = section.dataset.subVariantId;
        let otpVariantId = section.dataset.otpVariantId || subVariantId;
        const variantIdInput = section.querySelector('.mgn-special-shop__form input[name="id"]');
        const subImageUrl = section.dataset.subImage || null;
        const bestValueImageUrl = section.dataset.bestValueImage || null;
        const otpImageUrl = section.dataset.otpImage || null;
        const firstSlideImg = section.querySelector('#mainProduct-gallery .swiper-slide:first-child img');
        const firstThumbImg = section.querySelector('#mainProduct-thumbs .swiper-slide:first-child img');
        const originalSlideImgSrc = firstSlideImg ? firstSlideImg.src : null;
        const originalThumbImgSrc = firstThumbImg ? firstThumbImg.src : null;
        const bestValueQty = Number(section.dataset.bestValueQty) || 3;

        const flavorButtons = section.querySelectorAll('[data-mgn-variant-id]');
        const bundleSelects = section.querySelectorAll('[data-mgn-bundle-slot]');

        let currentVariantId = String(subVariantId || '');
        if (applyBogoUrlParams({ allowReload: true })) return;

        [subImageUrl, bestValueImageUrl, otpImageUrl, originalSlideImgSrc].forEach(function (url) {
          if (url) new Image().src = url;
        });

        function getPurchaseType() {
          if (!purchaseDiv) return 'sub';
          var type = purchaseDiv.getAttribute('data-purchase-type');
          if (type === 'otp' || type === 'bundle') return type;
          return 'sub';
        }

        function isSubscriptionType(type) {
          type = type || getPurchaseType();
          return type === 'sub' || type === 'bundle';
        }

        function getBundleItems(sellingPlan) {
          var counts = {};
          if (bundleSelects.length === 0) {
            var fallback = {
              id: Number(currentVariantId || subVariantId),
              quantity: bestValueQty
            };
            if (sellingPlan) fallback.selling_plan = sellingPlan;
            return [fallback];
          }
          bundleSelects.forEach(function (slotEl) {
            var id = String(slotEl.getAttribute('data-selected-id') || '');
            if (!id) return;
            counts[id] = (counts[id] || 0) + 1;
          });
          return Object.keys(counts).map(function (id) {
            var item = { id: Number(id), quantity: counts[id] };
            if (sellingPlan) item.selling_plan = sellingPlan;
            return item;
          });
        }

        function getOtpExtraVariantIds() {
          try {
            var parsed = JSON.parse(section.dataset.otpExtraVariants || '[]');
            return Array.isArray(parsed) ? parsed : [];
          } catch (_) {
            return [];
          }
        }

        function getSubExtraVariantIds() {
          try {
            var parsed = JSON.parse(section.dataset.subExtraVariants || '[]');
            return Array.isArray(parsed) ? parsed : [];
          } catch (_) {
            return [];
          }
        }

        function getOtpItems() {
          var flavorId = Number(otpVariantId || currentVariantId);
          var items = [];
          var seen = {};
          if (flavorId) {
            var otpItem = { id: flavorId, quantity: 1 };
            var otpPlan = Number(section.dataset.otpSellingPlanId || 0);
            if (otpPlan) otpItem.selling_plan = otpPlan;
            items.push(otpItem);
            seen[String(flavorId)] = true;
          }
          getOtpExtraVariantIds().forEach(function (id) {
            var extraId = Number(id);
            if (!extraId || seen[String(extraId)]) return;
            seen[String(extraId)] = true;
            items.push({ id: extraId, quantity: 1 });
          });
          return items;
        }

        function attachPromoProperties(items, isGift, giftCardProps) {
          var landingSource = getLandingSourceValue();
          return (items || []).map(function (item) {
            var next = Object.assign({}, item);
            var properties = Object.assign({}, item.properties || {}, { _nektar_glp1: 'true' });
            if (landingSource) {
              properties._landing_source = landingSource;
              properties.__landing_source = landingSource;
              if (isGift) properties._promo_gift = 'true';
            }
            if (giftCardProps && !isGift) {
              Object.assign(properties, giftCardProps);
            }
            next.properties = properties;
            return next;
          });
        }

        function updateHeroImage() {
          if (!firstSlideImg) return;

          const purchaseType = getPurchaseType();
          const variantKey = String(currentVariantId || subVariantId || '');
          const variantImages = mgnVariantImageMap[variantKey] || {};

          let targetUrl = null;

          if (purchaseType === 'otp') {
            targetUrl = variantImages.ot || otpImageUrl || originalSlideImgSrc;
          } else if (purchaseType === 'bundle') {
            targetUrl = bestValueImageUrl || variantImages.sb || originalSlideImgSrc;
          } else {
            targetUrl = variantImages.sb || subImageUrl || originalSlideImgSrc;
          }

          if (!targetUrl) return;

          firstSlideImg.src = targetUrl;
          firstSlideImg.removeAttribute('srcset');

          if (firstThumbImg) {
            firstThumbImg.src = targetUrl;
            firstThumbImg.removeAttribute('srcset');
          }

          ensureMainGallerySlideToFirst();
        }

        function selectVariant(variantId, scope) {
          if (!variantIdInput) return;
          scope = scope || getPurchaseType();
          if (scope === 'bundle') scope = 'sub';

          var root = section.querySelector('[data-mgn-flavor-scope="' + scope + '"]');
          var clicked = root
            ? root.querySelector('[data-mgn-variant-id="' + variantId + '"]')
            : section.querySelector('[data-mgn-variant-id="' + variantId + '"]');
          if (clicked && clicked.getAttribute('data-available') === 'false') return;

          if (root) {
            root.querySelectorAll('[data-mgn-variant-id]').forEach(function (btn) {
              const isActive = String(btn.dataset.mgnVariantId) === String(variantId);
              btn.classList.toggle('is-selected', isActive);
              btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
            });
          }

          currentVariantId = String(variantId);
          if (scope === 'otp') {
            otpVariantId = String(variantId);
          } else {
            subVariantId = String(variantId);
          }

          var type = getPurchaseType();
          if (type === 'otp') {
            variantIdInput.value = String(otpVariantId);
          } else if (type === 'sub') {
            variantIdInput.value = String(subVariantId);
          } else {
            variantIdInput.value = String(currentVariantId);
          }

          updateHeroImage();
          clearCartError();
        }

        function selectPurchaseOption(type) {
          optionCards.forEach(function (card) {
            const isThis = card.dataset.mgnOption === type;
            card.classList.toggle('is-selected', isThis);
            card.setAttribute('aria-checked', isThis ? 'true' : 'false');
          });
          if (purchaseDiv) purchaseDiv.setAttribute('data-purchase-type', type);
          var isSubLike = isSubscriptionType(type);
          if (planInput) {
            var planId = type === 'bundle'
              ? (planInput.getAttribute('data-bundle-plan-id') || planInput.getAttribute('data-plan-id'))
              : planInput.getAttribute('data-plan-id');
            if (isSubLike && planId) {
              planInput.setAttribute('name', 'selling_plan');
              planInput.value = planId;
              if (unlockedFreebies) unlockedFreebies.style.display = 'block';
            } else {
              planInput.removeAttribute('name');
              if (unlockedFreebies) unlockedFreebies.style.display = 'none';
            }
          }
          if (type === 'otp') {
            currentVariantId = String(otpVariantId || '');
            if (variantIdInput) variantIdInput.value = String(otpVariantId);
          } else if (type === 'bundle') {
            var firstBundle = bundleSelects[0]
              ? String(bundleSelects[0].getAttribute('data-selected-id') || subVariantId || '')
              : String(subVariantId || '');
            currentVariantId = firstBundle;
            if (variantIdInput) variantIdInput.value = firstBundle;
          } else {
            currentVariantId = String(subVariantId || '');
            if (variantIdInput) variantIdInput.value = String(subVariantId);
          }

          updateHeroImage();
        }

        optionCards.forEach(function (card) {
          card.addEventListener('click', function (e) {
            if (e.target.closest('select, option, button, label, a')) {
              selectPurchaseOption(this.dataset.mgnOption);
              return;
            }
            selectPurchaseOption(this.dataset.mgnOption);
          });
          card.addEventListener('keydown', function (e) {
            if (e.target && e.target.tagName === 'SELECT') return;
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              selectPurchaseOption(this.dataset.mgnOption);
            }
          });
        });

        flavorButtons.forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            var scopeEl = this.closest('[data-mgn-flavor-scope]');
            var scope = scopeEl ? scopeEl.getAttribute('data-mgn-flavor-scope') : 'sub';
            var parentCard = this.closest('[data-mgn-option]');
            if (parentCard) selectPurchaseOption(parentCard.dataset.mgnOption);
            selectVariant(this.dataset.mgnVariantId, scope);
          });
          btn.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
              var scopeEl = this.closest('[data-mgn-flavor-scope]');
              var scope = scopeEl ? scopeEl.getAttribute('data-mgn-flavor-scope') : 'sub';
              selectVariant(this.dataset.mgnVariantId, scope);
            }
          });
        });

        bundleSelects.forEach(function (slotEl) {
          var trigger = slotEl.querySelector('[data-mgn-bundle-trigger]');
          var dropdown = slotEl.querySelector('.mgn-special-shop__bundle-dropdown');
          var triggerLabel = slotEl.querySelector('.mgn-special-shop__bundle-trigger-label');
          if (!trigger || !dropdown) return;

          trigger.addEventListener('click', function (e) {
            e.stopPropagation();
            var parentCard = slotEl.closest('[data-mgn-option]');
            if (parentCard) selectPurchaseOption(parentCard.dataset.mgnOption);
            var willOpen = dropdown.hasAttribute('hidden');
            bundleSelects.forEach(function (other) {
              var otherDropdown = other.querySelector('.mgn-special-shop__bundle-dropdown');
              var otherTrigger = other.querySelector('[data-mgn-bundle-trigger]');
              if (otherDropdown) otherDropdown.setAttribute('hidden', '');
              if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
              other.classList.remove('is-open');
            });
            if (willOpen) {
              dropdown.removeAttribute('hidden');
              trigger.setAttribute('aria-expanded', 'true');
              slotEl.classList.add('is-open');
            }
          });

          slotEl.querySelectorAll('[data-mgn-bundle-option]').forEach(function (opt) {
            opt.addEventListener('click', function (e) {
              e.stopPropagation();
              var id = String(this.dataset.mgnBundleOption);
              slotEl.setAttribute('data-selected-id', id);
              slotEl.querySelectorAll('[data-mgn-bundle-option]').forEach(function (otherOpt) {
                var isActive = String(otherOpt.dataset.mgnBundleOption) === id;
                otherOpt.classList.toggle('is-selected', isActive);
                otherOpt.setAttribute('aria-selected', isActive ? 'true' : 'false');
              });
              if (triggerLabel) triggerLabel.innerHTML = this.innerHTML;
              dropdown.setAttribute('hidden', '');
              trigger.setAttribute('aria-expanded', 'false');
              slotEl.classList.remove('is-open');
              currentVariantId = id;
              if (variantIdInput) variantIdInput.value = id;
              updateHeroImage();
            });
          });
        });

        document.addEventListener('click', function () {
          bundleSelects.forEach(function (slotEl) {
            var dropdown = slotEl.querySelector('.mgn-special-shop__bundle-dropdown');
            var trigger = slotEl.querySelector('[data-mgn-bundle-trigger]');
            if (dropdown) dropdown.setAttribute('hidden', '');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
            slotEl.classList.remove('is-open');
          });
        });

        const checkoutWrap = section.querySelector('.mgn-special-shop__form');
        const checkoutBtn = section.querySelector('[data-mgn-checkout-cta]');
        const cartErrorEl = section.querySelector('[data-mgn-cart-error]');

        function clearCartError() {
          if (!cartErrorEl) return;
          cartErrorEl.textContent = '';
          cartErrorEl.setAttribute('hidden', '');
        }

        function showCartError(message) {
          if (!cartErrorEl) return;
          cartErrorEl.textContent = message || 'Unable to add to cart. Please try again.';
          cartErrorEl.removeAttribute('hidden');
        }

        // Keep form id in sync with the available selected flavor pill (Liquid may have remapped sold-out defaults)
        var selectedPill = section.querySelector('.mgn-special-shop__variant-pill.is-selected:not(.is-sold-out)');
        if (selectedPill && variantIdInput) {
          var selectedId = selectedPill.getAttribute('data-mgn-variant-id');
          if (selectedId) {
            variantIdInput.value = selectedId;
            currentVariantId = String(selectedId);
            subVariantId = String(selectedId);
          }
        }

        if (checkoutWrap && checkoutBtn) {
          checkoutBtn.addEventListener('click', function () {
            clearCartError();
            var purchaseType = getPurchaseType();
            var isSub = isSubscriptionType(purchaseType);
            if (isSub) applyBogoUrlParams();
            var ctaLabelEl = checkoutBtn.querySelector('[data-mgn-cta-label]');
            var ctaLabel = ctaLabelEl ? ctaLabelEl.textContent.trim() : 'Checkout';
            checkoutBtn.disabled = true;
            if (ctaLabelEl) ctaLabelEl.textContent = 'Adding products to cart…';
            var selectedCard = section.querySelector('[data-mgn-option].is-selected');
            var behavior = (selectedCard && selectedCard.dataset.atcBehavior) || section.dataset.atcBehavior;
            var openDrawer = behavior === 'drawer';
            if (!openDrawer) setCheckoutRedirectGuard();

            var variantId = Number(checkoutWrap.querySelector('input[name="id"]').value);
            var qty = Number(checkoutWrap.querySelector('input[name="quantity"]').value) || 1;
            var spInput = checkoutWrap.querySelector('.mgn-special-shop__selling-plan');
            var sellingPlan = (spInput && spInput.getAttribute('name')) ? Number(spInput.value) : null;

            var mainItems;
            if (purchaseType === 'bundle') {
              mainItems = getBundleItems(sellingPlan);
            } else if (purchaseType === 'otp') {
              mainItems = getOtpItems();
            } else {
              var mainItem = { id: variantId, quantity: qty };
              if (sellingPlan) mainItem.selling_plan = sellingPlan;
              mainItems = [mainItem];
            }

            var discountCodes = getDiscountCodesForPurchaseType(purchaseType);
            var useBogoFlow = isSub && sectionConfig.bogoUrlParamsEnabled;
            var shouldClearCart = section.dataset.clearCart !== 'false';

            function resetSubmitBtn() {
              checkoutBtn.disabled = false;
              if (ctaLabelEl) ctaLabelEl.textContent = ctaLabel;
              clearCheckoutRedirectGuard();
            }

            function redirectToCheckout() {
              if (isSub) applyBogoUrlParams();
              window.location.href = getCheckoutUrlWithCurrentParams(discountCodes, isSub);
            }

            function finishAfterAdd(addResult) {
              if (!openDrawer) return redirectToCheckout();
              clearCheckoutRedirectGuard();
              var drawer = document.querySelector('cart-drawer');
              var sectionPayload = (addResult && addResult.sections)
                ? { id: variantId, sections: addResult.sections }
                : null;
              var canRender = !!(drawer
                && sectionPayload
                && typeof drawer.renderContents === 'function'
                && typeof drawer.hasRequiredSections === 'function'
                && drawer.hasRequiredSections(sectionPayload));

              function onPaintFail(err) {
                showCartError(err && err.message ? err.message : 'Unable to add to cart. Please try again.');
                resetSubmitBtn();
              }

              function repaintDrawer(sections) {
                var payload = { id: variantId, sections: sections || {} };
                if (!drawer.hasRequiredSections(payload)) return;
                if (drawer.classList.contains('active') && typeof drawer.renderContents === 'function') {
                  return drawer.renderContents(payload);
                }
                drawer.getSectionsToRender().forEach(function (section) {
                  var el = section.selector
                    ? document.querySelector(section.selector)
                    : document.getElementById(section.id);
                  if (!el || !payload.sections[section.id]) return;
                  el.innerHTML = drawer.getSectionInnerHTML(payload.sections[section.id], section.selector);
                });
              }

              if (canRender) {
                return Promise.resolve().then(function () {
                  return drawer.renderContents(sectionPayload);
                }).then(function () {
                  resetSubmitBtn();
                  if (!discountCodes.length) return;
                  applyDiscountCodes(discountCodes).then(function () {
                    var ids = drawer.getSectionsToRender().map(function (section) { return section.id; }).join(',');
                    return fetch('/?sections=' + encodeURIComponent(ids), {
                      method: 'GET',
                      headers: { Accept: 'application/json' },
                      credentials: 'same-origin',
                    }).then(function (res) {
                      if (!res.ok) throw new Error('Failed cart section refresh');
                      return res.json();
                    }).then(repaintDrawer);
                  }).catch(function (err) { console.error(err); });
                }, function () {
                  if (typeof drawer.refreshSections !== 'function') return onPaintFail();
                  return drawer.refreshSections({ openDrawer: true, productId: variantId }).then(resetSubmitBtn, onPaintFail);
                });
              }

              var ready = applyDiscountCodes(discountCodes);
              if (drawer && typeof drawer.refreshSections === 'function') {
                return ready
                  .then(function () { return drawer.refreshSections({ openDrawer: true, productId: variantId }); })
                  .then(resetSubmitBtn, onPaintFail);
              }
              return ready.then(redirectToCheckout, onPaintFail);
            }

            if (useBogoFlow) {
              var giftCardProps = getGiftCardProperties(isSub);
              clearCartIfNeeded(shouldClearCart)
                .then(function () {
                  return postAdd(attachPromoProperties(mainItems, false, giftCardProps), false);
                })
                .then(function (addResult) {
                  var itemCountAfterAdd = (addResult && typeof addResult.items !== 'undefined')
                    ? addResult.items.length
                    : 1;
                  return waitForBogoGift(itemCountAfterAdd);
                })
                .then(function () { return finishAfterAdd(null); })
                .catch(function (err) {
                  console.error(err);
                  showCartError(err && err.message ? err.message : 'Unable to add to cart. Please try again.');
                  resetSubmitBtn();
                });
              return;
            }

            var giftCardPropsNative = getGiftCardProperties(isSub);
            var taggedItems = attachPromoProperties(mainItems, false, giftCardPropsNative);
            if (isSub) {
              var extraIds = purchaseType === 'bundle'
                ? (function () {
                    try {
                      var parsed = JSON.parse(section.dataset.bestValueExtraVariants || '[]');
                      return Array.isArray(parsed) ? parsed : [];
                    } catch (_) { return []; }
                  })()
                : [];
              if (!extraIds.length) extraIds = getSubExtraVariantIds();
              extraIds.forEach(function (id) {
                var extraId = Number(id);
                if (!extraId) return;
                taggedItems.push(attachPromoProperties([{ id: extraId, quantity: 1 }], true, null)[0]);
              });
            }

            if (isSub) {
              var discountData = [];
              try { discountData = JSON.parse(section.dataset.discountBlocks || '[]'); } catch (_) {}
              discountData.forEach(function (d) {
                if (d.variant_id) {
                  taggedItems.push({ id: Number(d.variant_id), quantity: 1 });
                }
              });
            }

            clearCartIfNeeded(shouldClearCart)
              .then(function () { return postAdd(taggedItems, openDrawer); })
              .then(finishAfterAdd)
              .catch(function (err) {
                console.error(err);
                showCartError(err && err.message ? err.message : 'Unable to add to cart. Please try again.');
                resetSubmitBtn();
              });
          });
        }

        const faqList = section.querySelector('.mgn-special-shop__faq-list');
        if (faqList) {
          const items = faqList.querySelectorAll('[data-mgn-special-faq-item]');
          const triggers = faqList.querySelectorAll('[data-mgn-special-faq-trigger]');

          triggers.forEach((btn) => {
            btn.addEventListener('click', function () {
              const item = this.closest('[data-mgn-special-faq-item]');
              const panel = item.querySelector('.mgn-special-shop__faq-panel');
              const isOpen = item.classList.contains('mgn-special-shop__faq-item--open');

              if (isOpen) {
                item.classList.remove('mgn-special-shop__faq-item--open');
                this.setAttribute('aria-expanded', 'false');
                if (panel) panel.setAttribute('aria-hidden', 'true');
              } else {
                items.forEach((other) => {
                  other.classList.remove('mgn-special-shop__faq-item--open');
                  const otherBtn = other.querySelector('[data-mgn-special-faq-trigger]');
                  const otherPanel = other.querySelector('.mgn-special-shop__faq-panel');
                  if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
                  if (otherPanel) otherPanel.setAttribute('aria-hidden', 'true');
                });
                item.classList.add('mgn-special-shop__faq-item--open');
                this.setAttribute('aria-expanded', 'true');
                if (panel) panel.setAttribute('aria-hidden', 'false');
              }
            });
          });
        }

        var initialCard = section.querySelector('[data-mgn-option].is-selected');
        if (initialCard && initialCard.dataset.mgnOption) {
          selectPurchaseOption(initialCard.dataset.mgnOption);
        }

        updateHeroImage();
  }

  function boot() {
    document.querySelectorAll('[data-mgn-special-shop]').forEach(initMgnSpecialShop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-mgn-special-shop]')
      : null;
    if (root) {
      root.dataset.mgnSpecialBound = 'false';
      initMgnSpecialShop(root);
    }
  });
})();
